<template lang="pug">

.stark
  .stark-intro.u-section-full.u-section-padding.u-textCenter
    svg(xmlns='http://www.w3.org/2000/svg', width='90', height='86')
      path(fill-rule='evenodd', fill='#FFF', d='M90 62.544v23.455H0V62.544h64.737v-7.818H0V-.002l23.684.001H90v23.453H23.684v7.82H90v31.272z')
    h1.u-mh-xs {{$t('pageTitle')}}
    h5.u-mb-xm {{$t('mantra')}}
    .u-textCenter
      AppLink(to="https://baianat.com/files/file10ziw1jr66buew" class="button is-rounded is-wide ") {{$t('freeDownload')}}
    img.stark-intro-img(src='https://cdn.baianat.com/static/resources/stark/2.png', srcset='https://cdn.baianat.com/static/resources/stark/2.png 1x, https://cdn.baianat.com/static/resources/stark/2@2x.png 2x')

  section.stark-numbers.u-textCenter
    AppTitle.u-mb-xm(:title="$t('corporateNews')" tag="h3")

    .grid.is-widescreen-6.is-desktop-8.is-tablet-10.is-center
      .column
        p {{$t('corporateNewsDesc')}}

    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center.u-mb-sm
      .column
        .grid.is-tablet-4.u-mt-sm
          .column.u-mb-sm
            img.stark-numbers-img(src='https://cdn.baianat.com/static/resources/stark/3.png', srcset='https://cdn.baianat.com/static/resources/stark/3.png 1x, https://cdn.baianat.com/static/resources/stark/3@2x.png 2x')
            h4.u-mh-ts + 200
            p {{$t('components')}}
          .column.u-mb-sm
            img.stark-numbers-img(src='https://cdn.baianat.com/static/resources/stark/4.png', srcset='https://cdn.baianat.com/static/resources/stark/4.png 1x, https://cdn.baianat.com/static/resources/stark/4@2x.png 2x')
            h4.u-mh-ts + 90
            p {{$t('elements')}}
          .column.u-mb-sm
            img.stark-numbers-img(src='https://cdn.baianat.com/static/resources/stark/5.png', srcset='https://cdn.baianat.com/static/resources/stark/5.png 1x, https://cdn.baianat.com/static/resources/stark/5@2x.png 2x')
            h4.u-mh-ts + 10
            p {{$t('categories')}}

  section.stark-gray.u-textCenter.u-section-full.u-section-padding
    h2.u-mt-lg {{$t('components')}}
    .grid.is-widescreen-6.is-desktop-8.is-tablet-10.is-center
      .column
        p.u-mb-sm  {{$t('componentsDesc')}}
      img(src='https://cdn.baianat.com/static/resources/stark/6.png', srcset='https://cdn.baianat.com/static/resources/stark/6.png 1x, https://cdn.baianat.com/static/resources/stark/6@2x.png 2x')

  section.stark-arabic.u-textCenter.u-section-full.u-section-padding
    h2.u-mt-lg  {{$t('arabicUi')}}
    .grid.is-widescreen-6.is-desktop-8.is-tablet-10.is-center.u-mb-md
      .column
        p.u-mb-sm {{$t('arabicUiDesc')}}
      img(src='https://cdn.baianat.com/static/resources/stark/7.png', srcset='https://cdn.baianat.com/static/resources/stark/7.png 1x, https://cdn.baianat.com/static/resources/stark/7@2x.png 2x')

  section.u-mt-lg
    .grid.is-middle
      .column.u-mb-sm.is-desktop-5
        img.u-img(src='https://cdn.baianat.com/static/resources/stark/8.png', srcset='https://cdn.baianat.com/static/resources/stark/8.png 1x, https://cdn.baianat.com/static/resources/stark/8@2x.png 2x')
      .column.u-mb-sm.is-desktop-4
        h4 {{$t('colorsPalette')}}
        p {{$t('colorsPaletteDesc')}}

    .grid.is-middle.u-textCenter.u-mt-sm
      .column.is-desktop-5
      .column.u-mb-sm.is-desktop-7
        img.u-img(src='https://cdn.baianat.com/static/resources/stark/9.png', srcset='https://cdn.baianat.com/static/resources/stark/9.png 1x, https://cdn.baianat.com/static/resources/stark/9@2x.png 2x')
        h4.u-mt-xs {{$t('flatIcons')}}
        p {{$t('flatIconsDesc')}}
    .grid.is-middle.u-textCenter.u-mt-sm
      .column.is-desktop-1
      .column.u-mb-sm.is-desktop-7
        img.u-img(src='https://cdn.baianat.com/static/resources/stark/10.png', srcset='https://cdn.baianat.com/static/resources/stark/10.png 1x, https://cdn.baianat.com/static/resources/stark/10@2x.png 2x')
        h4.u-mt-xs {{$t('wiredIcons')}}
        p {{$t('wiredIconsDesc')}}

    .grid.is-middle.u-mt-sm.is-center
      .column.u-mb-sm.is-desktop-4
        h4.u-mb-xs {{$t('googleFont')}}
        p.u-mb-xs {{$t('googleFontDesc')}}
        p {{$t('eA')}}
      .column.u-mb-sm.is-desktop-5
        img.u-img(src='https://cdn.baianat.com/static/resources/stark/19.png', srcset='https://cdn.baianat.com/static/resources/stark/19.png 1x, https://cdn.baianat.com/static/resources/stark/19@2x.png 2x')


  section.stark-gray.u-textCenter.u-section-full.u-section-padding
    h2.u-mt-lg.u-mb-sm  {{$t('brightVersion')}}
    img.u-img(src='https://cdn.baianat.com/static/resources/stark/11.png', srcset='https://cdn.baianat.com/static/resources/stark/11.png 1x, https://cdn.baianat.com/static/resources/stark/11@2x.png 2x')


  section.stark-dark.u-textCenter.u-section-full.u-section-padding
    h2.u-mt-lg.u-mb-sm  {{$t('darkVersion')}}
    img.u-img(src='https://cdn.baianat.com/static/resources/stark/12.png', srcset='https://cdn.baianat.com/static/resources/stark/12.png 1x, https://cdn.baianat.com/static/resources/stark/12@2x.png 2x')


  section.stark-features.u-section-full.u-section-padding
    AppTitle.u-mb-sm(:title="$t('starkFeatures')" tag="h2")

    .grid.is-desktop-4.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('starkFeaturesItems')")
        img(:src='`https://cdn.baianat.com/static/resources/stark/${12 + Number(idx)}.png`', :srcset='`https://cdn.baianat.com/static/resources/stark/${12 + Number(idx)}.png 1x, https://cdn.baianat.com/static/resources/stark/${12 + Number(idx)}@2x.png 2x`')
        h5.u-mh-xs {{item.title}}
        p {{item.desc}}


  section.stark-cta.u-section-full.u-section-padding.u-textCenter
    h2.u-mb-xs {{$t('starkUi')}}
    p.u-mb-xm.u-text-lg(v-html="$t('starkUiDesc')")
    AppLink(to="https://baianat.com/files/file10ziw1jr66buew" class="button is-rounded is-wide is-white" :title="$t('freeDownload')") {{$t('freeDownload')}}


</template>

<style lang="stylus">
$clMain = #ff5063
$clDark = #0f1c2f
$clBlue = #0ac8fb
$clYellow = #ffbc03
$clGreen = #00b06c
$clGray = #f6f6f6

div.app.is-stark
  overflow: hidden

  .header.is-scroll
    background: $clMain
    color: $clWhite !important

  .footer
    border-top: none

.stark
  position: relative
  z-index: 1

  &-intro
    background-color: $clMain
    color: $clWhite
    padding-top: unitRes(240, 400)
    z-index: 1
    position: relative
    text-shadow: 1px 1px 11px alpha($clBlack, 0.2)
    margin-bottom: unitRes(100, 300)
    background: url('https://cdn.baianat.com/static/resources/stark/1@2x.png') no-repeat top center $clMain

    &-img
      margin-top: unitRes(60, 200)
      margin-bottom: -160px

      +mq($until: 'widescreen')
        margin-bottom: -14%

  &-numbers
    &-img
      max-height: 190px

  &-gray
    background: $clGray
    overflow: hidden

  &-arabic
    background: $clYellow
    overflow: hidden
    color: $clWhite

  &-dark
    background: $clDark
    color: $clWhite
    overflow: hidden

  &-features
    background: $clGreen
    color: $clWhite
    padding-top: unitRes(100, 200)
    padding-bottom: unitRes(50, 100)

    img
      height: 70px
      width: auto

  &-cta
    background: $clDark
    color: $clWhite
    padding-top: unitRes(100, 200)
    padding-bottom: unitRes(100, 200)
</style>

<script>
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,

  meta: {
    theme: 'is-stark is-whiteHeader is-fixedHeader',
    logoText: '__NONE__'
  },
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Stark UI Kit",
    "pageDesc":"Stark is a vivid UI Kit that can be customized and used for many fields including business, advertising, and e-commerce.",
    "mantra":"UI KIT",
    "freeDownload":"Free Download",
    "corporateNews":"Corporate, News and |Ecommerce",
    "corporateNewsDesc":"Stark UI Kit can be customized and used as appropriate for many fields including business, advertising, e-commerce, news agencies, etc.",
    "components":"Components",
    "elements":"Elements",
    "categories":"Categories",
    "componentsDesc":"Stark UI Kit includes many UI components in smooth, brilliant and attractive designs. These components can be customized to meet all your needs.",
    "arabicUi":"Arabic UI",
    "arabicUiDesc":"Stark UI Kit is developed with features to fit all Latin languages as well as Right-to-Left languages including Arabic. That is how it is really universal.",
    "colorsPalette":"colors palette",
    "colorsPaletteDesc":"There is a variety of colors used in Stark UI Kit for a vivid UI look suitable for different tastes.",
    "flatIcons":"128 flat Icons",
    "flatIconsDesc":"Stark UI Kit consists of 128 flat colored icons #[br] suitable for many different uses.",
    "wiredIcons":"128 Wired Icons",
    "wiredIconsDesc":"Stark UI Kit consists of 128 wired/lined icons #[br] suitable for many different uses.",
    "googleFont":"Google Font",
    "googleFontDesc":"The main font used for Stark UI Kit is Google Font. This font has delicate shape of letters and numbers and it is appropriate for business format.",
    "eA":"English - Arabic",
    "brightVersion":"Bright Version",
    "darkVersion":"Dark Version",
    "starkFeatures":"Stark icon |features",
    "starkFeaturesItems":{
      "1":{
        "title":"Perfect Pixel",
        "desc":"All components in Stark UI Kit are in perfect pixels to ensure very high quality."
      },
      "2":{
        "title":"RTL & LTR",
        "desc":"Enjoy the multiple-language support by Stark UI Kit and release your limitless creativity."
      },
      "3":{
        "title":"Icons Bundle",
        "desc":"With Stark UI Kit you will enjoy not only UI components, but also multi-use bundle of icons."
      },
      "4":{
        "title":"Vector Shapes",
        "desc":"UI in small pixels confusing ? Stark UI components are in vector shape to ensure perfect look."
      },
      "5":{
        "title":"Colors Pallets",
        "desc":"A variety of vivid and bright colors bringing life and beauty to the interface to engage users’ minds and hearts."
      },
      "6":{
        "title":"Dark and Bright",
        "desc":"Stark UI Kit can be used in two UI versions; dark and bright. Select the version appropriate for your business, service, etc."
      }
    },
    "starkUi":"Stark UI",
    "starkUiDesc":"Enjoy the full free UI Kit bundle with <br> its two versions."
  },
  "ar": {
    "pageTitle":"واجهة ستارك",
    "pageDesc":"هي مجموعة من أدوات واجهة المستخدم يمكن تخصيصها واستخدامها في العديد من المجالات بما في ذلك الأعمال التجارية والإعلان.",
    "mantra":"مكونات واجهة المستخدم",
    "freeDownload":"حمل مجانًا.",
    "corporateNews":"الشركات والوكالات |والتجارة الإلكترونية.",
    "corporateNewsDesc":"ستارك هي مجموعة فريدة من أدوات واجهة المستخدم التي يمكن تخصيصها واستخدامها في العديد من المجالات بما في ذلك، الأعمال التجارية، والإعلانات، و التجارة الإلكترونية، ووكالات الأنباء… وما إلى ذلك.",
    "components":"مكونات",
    "elements":"عنصر",
    "categories":"أقسام",
    "componentsDesc":"ستارك يتضمن العديد من مكونات واجهة المستخدم في تصاميم مميزة ورائعة وجذابة. يمكن تخصيص هذه المكونات لتلبية جميع احتياجاتك.",
    "arabicUi":"واجهة المستخدم العربية",
    "arabicUiDesc":"استمتع بمجموعة من أدوات واجهة المستخدم التي تأتي بجميع اللغات اللاتينية بالإضافة إلى اللغات التي تكتب من اليمين إلى اليسار بما فيهم اللغة العربية.",
    "colorsPalette":"لوحة الألوان",
    "colorsPaletteDesc":"ستارك يحتوي على مجموعة متنوعة من الألوان للحصول على مظهر جذاب لواجهة المستخدم.",
    "flatIcons":"128 أيقونة مسطحة",
    "flatIconsDesc":"يتكون ستارك من 128 أيقونة ملونة ومسطحة مناسبة للعديد من الاستخدامات المختلفة.",
    "wiredIcons":"128 أيقونة خطية",
    "wiredIconsDesc":"يتألف ستارك من 128 أيقونة خطية مناسبة للعديد من الاستخدامات المختلفة.",
    "googleFont":"خط جوجل",
    "googleFontDesc":"الخط الرئيسي المستخدم في ستارك هو خط جوجل.هذا الخط لديه شكل دقيق من الحروف والأرقام و مناسب لتنسيق الأعمال.",
    "eA":"الإنجليزية - العربية",
    "brightVersion":"النسخة الفاتحة",
    "darkVersion":"النسخة الداكنة",
    "starkFeatures":"مميزات |ستارك",
    "starkFeaturesItems":{
      "1":{
        "title":"البيكسل المثالي",
        "desc":"أثناء تصميم ستارك لواجهة المستخدم اتبعنا قواعد البيكسل المثالية لضمان جودة عالية."
      },
      "2":{
        "title":"RTL & LTR",
        "desc":"استمتع بالدعم متعدد اللغات من قبل أدوات ستارك لواجهة المستخدم واحصل على تصميمات فريدة في ثوان معدودة."
      },
      "3":{
        "title":"مجموعة الأيقونات",
        "desc":"المكونات وحدها لا تكفي، أكمل ظهورك المرئي من خلال أيقونات مخصصة تأتي مع مظهر مسطح و خطي."
      },
      "4":{
        "title":"أشكال المتجهات Vector",
        "desc":"البكسل الصغير يعتبر مربك في واجهة المستخدم؟! مكونات واجهة المستخدم ستارك هي في شكل vector لضمان مظهر مثالي."
      },
      "5":{
        "title":"لوحات الألوان",
        "desc":"تجربة ألوان غير متوقعة حيث يمكنك تخصيصها لإضفاء المظهر الدافئ أو البارد...أو غيره."
      },
      "6":{
        "title":"الداكن والفاتح",
        "desc":"يمكنك استخدام أدوات واجهة المستخدم من كلا الاصدارين، الداكن والفاتح.حدد الإصدار المناسب مع نشاطك التجاري."
      }
    },
    "starkUi":"ستارك مكونات واجهة المستخدم",
    "starkUiDesc":"استمتع بمجموعة مكونات واجهة المستخدم الكاملة المجانية بالنسختين الفاتحة والداكنة."
  }
}
</i18n>
